import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { ProjectContext } from 'contexts/project/ProjectContext';
import { useProjectDetailStore } from 'store/local/projectDetail';
import { T } from 'components/common/text';
import CustomSpan from 'components/common/text/CustomSpan';
import MuiButton from 'components/common/button/MuiButton';
import ProjectFileList from './ProjectFileList';
import ProjectFileViewer from './ProjectFileViewer';
import ProjectSyncPartner from './ProjectSyncPartner';
import { AppActions, FileActions } from 'store/actionCreators';
import { useProjectFileStore } from 'store/local/projectFile';
import { useProjectFiles } from 'lib/hooks/project/useProjectFiles';
import { useDidUpdateEffect } from 'lib/utils';
import { useTranslation } from 'react-i18next';
import { useProject } from 'lib/hooks/project/useProject';
import { handleClearPmsData, pmsViewThumbnail } from 'containers/base/PmsConnect';
import { IConvertFile } from 'lib/types/clinic/fileTypes';
import { fetchProductData } from 'api/dashboard';
import CustomText from 'components/common/text/CustomText';

interface ProjectContentsFileProps {
  className?: string;
}

function ProjectContentsFile({ className }: ProjectContentsFileProps) {
  // SECTION: state

  const [buildProcessing, setBuildProcessing] = useState<boolean>(false);
  const [localFileAllUploadValid, setLocalFileAllUploadValid] = useState<boolean>(false);
  const [newSyncPartnerValid, setNewSyncPartnerValid] = useState<boolean>(false);
  const [syncPartnerValid, setSyncPartnerValid] = useState<boolean>(false);
  const [syncGroupValid, setSyncGroupValid] = useState<boolean>(false);

  const [scanUpperCheckStart, setScanUpperCheckStart] = useState<boolean>(false);
  const [scanLowerCheckStart, setScanLowerCheckStart] = useState<boolean>(false);
  const [scanOcclusionCheckStart, setScanOcclusionCheckStart] = useState<boolean>(false);

  const { ipcRenderer } = window;
  const { user, classifyClinicFiles } = useContext(ProjectContext);
  const {
    handleClickSyncNewPartner,
    handleClearAllCheckbox,
    handlePmsThumbnailAutoView,
    handleClearAllView,
    handleClickAllLocalFileUploadToPartner,
    handleCheckDuplicateUploadFile,
    handleScanFiilAutoView,
    handleScanFiilAutoViewer,
  } = useProjectFiles();
  const {
    selectedSyncPartner,
    setSelectedSyncPartner,
    setNewSyncPartner,
    queryPageTab,
    setQueryPageTab,
  } = useProjectDetailStore();
  const { uploadShareType, isPmsView } = useProjectFileStore();

  const { newSyncPartner } = useProjectDetailStore();

  const {
    projectCode,
    projectInfo,
    editProjectShareSuccess,
    createProjectSyncSuccess,
    isPmsReady,
    pmsCommand,
    isPmsOrder,
    scanFileExists,
    scanProcess,
    scanEdit,
  } = useProject();
  const { t } = useTranslation();
  const { company } = user;
  const {
    upperFiles,
    lowerFiles,
    occlusionFiles,
    checkedClinicFiles,
    clinicLoadLocalFilesDataList,
    clinicSortedAllLocalFileList,
    clinicLocalFileList,
    clinicViewModelFiles,
    scanShowiles,
    scanLowerShowFiles,
    scanUpperShowFiles,
    scanOcclusionShowFiles,
    scanFileReady,
  } = classifyClinicFiles;

  const { partnershipCode, projectId, syncInfo, partnerIdx, partnerName } = projectInfo;

  useDidUpdateEffect(async () => {
    if (
      !!ipcRenderer &&
      clinicLoadLocalFilesDataList.value.length > 0 &&
      (checkedClinicFiles.value.length === clinicLoadLocalFilesDataList.value.length ||
        clinicSortedAllLocalFileList.value.length === clinicLoadLocalFilesDataList.value.length)
    ) {
      console.log('HDS] 여기 실행이 되는건가??? SYNC');
      const submitData = {
        isShare: uploadShareType,
        syncPartnerId: newSyncPartner,
        company,
        projectCode: projectCode,
        project: clinicLoadLocalFilesDataList.value,
        projectId,
        type: 'upload',
      };
      console.log('HDS] 여기 실행이 되는건가???  _____ ', submitData);
      const ableUpload = await checkAbailableStorage(clinicLoadLocalFilesDataList.value);
      console.log('HDS] ableUpload ', ableUpload);
      if (!ableUpload) {
        AppActions.add_popup({
          isOpen: true,
          width: 660,
          title: <T>GLOBAL_ANNOUNCEMENT</T>,
          content: (
            <div style={{ textAlign: 'center' }}>
              <CustomText fontSize={20} fontColor="#303030" marginTop={20}>
                <T>GLOBAL_DISABLED_FILE_UPLOAD</T>
              </CustomText>
            </div>
          ),
          onClick() {
            return;
          },
        });
        clinicLoadLocalFilesDataList.setValue([]);
        clinicSortedAllLocalFileList.setValue([]);
        return;
      }
      console.log('HDS] upload_project_file_request continue');

      FileActions.upload_project_file_request(submitData);
      clinicLoadLocalFilesDataList.setValue([]);
      clinicSortedAllLocalFileList.setValue([]);
    }
  }, [
    checkedClinicFiles.value,
    uploadShareType,
    newSyncPartner,
    clinicLoadLocalFilesDataList.value,
    clinicSortedAllLocalFileList.value,
    company,
    projectCode,
  ]);

  const checkAbailableStorage = async (uploadFileListData: any[]) => {
    let uploadTotal = 0;
    uploadFileListData.forEach((item: any) => {
      uploadTotal = uploadTotal + item.file.size;
    });
    try {
      const response = await fetchProductData();
      if (response.data.status === 200) {
        const remainSize = response.data.dataInfo.remainSize * 1024 * 1024 * 1024;
        console.log('HDS] uploadTotal', uploadTotal);
        console.log('HDS] remainSize', remainSize);
        if (uploadTotal > remainSize) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
      // data = responseData;
    } catch (error) {
      return false;
    }
  };

  useDidUpdateEffect(() => {
    if (!editProjectShareSuccess) return;
    FileActions.fetch_project_files_request(projectCode);
    clinicSortedAllLocalFileList.setValue([]);
    handleClearAllCheckbox();
  }, [!!editProjectShareSuccess, projectCode]);

  useDidUpdateEffect(() => {
    if (!createProjectSyncSuccess) return;
    FileActions.fetch_project_files_request(projectCode);
  }, [createProjectSyncSuccess, selectedSyncPartner]);

  useEffect(() => {
    // 스캔 파일 체크 시작 - Upper 부터 > Lower -> Occlusion
    if (!!queryPageTab && !!scanFileExists && !!scanFileReady.value) {
      setScanUpperCheckStart(true);
    }
  }, [queryPageTab, scanFileExists, scanFileReady.value]);

  useEffect(() => {
    console.log('HDS] upperFiles.value _____', upperFiles.value);
  }, [upperFiles.value]);

  useEffect(() => {
    if (!scanUpperCheckStart) return;
    if (upperFiles.value.length < scanLowerShowFiles.value.length) return;

    if (upperFiles.value.length > 0) {
      const checkScanUpper = async () => {
        const data = await handleScanFiilAutoViewer(upperFiles.value, 'UPPER'); // 함수 실행
        const { count, chagedValue } = data;
        console.log('HDS] checkScanUpper count ____ ', count);
        if (count === scanLowerShowFiles.value.length) {
          setScanUpperCheckStart(false);
          setScanLowerCheckStart(true);
        }
        // upperFiles.setValue(chagedValue);
      };
      checkScanUpper();
    } else {
      setScanUpperCheckStart(false);
      setScanLowerCheckStart(true);
    }
  }, [scanUpperCheckStart, upperFiles.value, scanUpperShowFiles.value]);

  useEffect(() => {
    if (!scanLowerCheckStart) return;
    if (lowerFiles.value.length < scanLowerShowFiles.value.length) return;
    if (lowerFiles.value.length > 0) {
      const checkScanLower = async () => {
        const data = await handleScanFiilAutoViewer(lowerFiles.value, 'LOWER'); // 함수 실행
        const { count, chagedValue } = data;
        console.log('HDS] checkScanLower count ____ ', count);
        if (count === scanLowerShowFiles.value.length) {
          setScanLowerCheckStart(false);
          setScanOcclusionCheckStart(true);
        }
        // lowerFiles.setValue(chagedValue);
      };
      checkScanLower();
    } else {
      setScanLowerCheckStart(false);
      setScanOcclusionCheckStart(true);
    }
  }, [scanLowerCheckStart, lowerFiles.value, scanLowerShowFiles.value]);

  useEffect(() => {
    if (!scanOcclusionCheckStart) return;
    if (occlusionFiles.value.length < scanOcclusionShowFiles.value.length) return;
    if (occlusionFiles.value.length > 0) {
      // let count = 0;
      const checkScanOcclusion = async () => {
        // let count = 0;
        const data = await handleScanFiilAutoViewer(occlusionFiles.value, 'OCCLUSION'); // 함수 실행
        const { count, chagedValue } = data;
        console.log('HDS] checkScanOcclusion count ____ ', count);
        if (count === scanOcclusionShowFiles.value.length) {
          setScanOcclusionCheckStart(false);
          const urlWithoutQuery = window.location.origin + window.location.pathname; // Query string 제외한 URL 생성
          window.history.replaceState({}, document.title, urlWithoutQuery);
          setScanUpperCheckStart(false);
        }
        // occlusionFiles.setValue(chagedValue);
      };
      checkScanOcclusion();
    } else {
      setScanOcclusionCheckStart(false);
      const urlWithoutQuery = window.location.origin + window.location.pathname; // Query string 제외한 URL 생성
      window.history.replaceState({}, document.title, urlWithoutQuery);
      setScanUpperCheckStart(false);
    }
  }, [scanOcclusionCheckStart, occlusionFiles.value, scanOcclusionShowFiles.value]);

  useDidUpdateEffect(() => {
    // NOTE: PMS ViewThumbnail
    if (!isPmsOrder) return;
    if (pmsCommand !== pmsViewThumbnail) return;
    if (!isPmsReady) return;
    handleClearAllView();

    if (!isPmsView && scanFileExists === 1 && scanShowiles.value.length > 0) {
      console.log('HDS] isPmsView Start _______________ ');
      // handlePmsThumbnailAutoView();
      setScanUpperCheckStart(true);
    } else {
      handleClearPmsData();
    }
  }, [
    isPmsView,
    isPmsReady,
    isPmsOrder,
    pmsCommand,
    pmsViewThumbnail,
    scanFileExists,
    scanShowiles.value,
    clinicViewModelFiles.value,
    upperFiles.value,
    lowerFiles.value,
    occlusionFiles.value,
  ]);

  useEffect(() => {
    const sortLocalFile = clinicLocalFileList.value.filter((file: IConvertFile) => {
      return !!file?.isLocalStorage;
    });
    if (!!syncInfo || !!selectedSyncPartner) {
      if (sortLocalFile.length > 0) {
        setLocalFileAllUploadValid(true);
      } else {
        setLocalFileAllUploadValid(false);
      }
    } else {
      setLocalFileAllUploadValid(false);
    }
  }, [clinicLocalFileList.value, syncInfo, selectedSyncPartner]);

  useEffect(() => {
    if (!!syncInfo) {
      if (checkedClinicFiles.value.length > 0) {
        setNewSyncPartnerValid(true);
      } else {
        setNewSyncPartnerValid(false);
      }
    } else if (!syncInfo && !!selectedSyncPartner) {
      setNewSyncPartnerValid(true);
    } else {
      setNewSyncPartnerValid(false);
    }
  }, [selectedSyncPartner, checkedClinicFiles.value, syncInfo]);

  useEffect(() => {
    if (checkedClinicFiles.value.length > 0) {
      setSyncPartnerValid(
        !checkedClinicFiles.value.find((file: IConvertFile) => !file.isLocal && !file.isOwner),
      );
      setSyncGroupValid(!!checkedClinicFiles.value.find((file: IConvertFile) => !!file.isLocal));
    } else {
      setSyncPartnerValid(false);
      setSyncGroupValid(false);
    }
  }, [checkedClinicFiles.value]);

  useEffect(() => {
    if (!scanProcess?.command || !scanProcess?.data) {
      setBuildProcessing(false);
    } else {
      console.log(
        '스캔 빌드 및 업로드 중에 파일 업로드 막기 ___________ ',
        scanProcess?.command,
        ' ___ ',
        scanProcess?.data,
      );
      const isBuilding = ['startBuild', 'progressBuild', 'finishBuild'].some(
        item => item === scanProcess.command,
      );
      if (!!isBuilding && scanProcess.data.projectCode === projectCode) {
        setBuildProcessing(true);
      } else {
        setBuildProcessing(false);
      }
    }
  }, [scanProcess, projectCode]);

  useEffect(() => {
    return () => {
      setBuildProcessing(false);
    };
  }, []);

  return (
    <StyledProjectContentsFile data-component-name="ProjectContentsFile" className={className}>
      <div className="projectContentsFile__container">
        <div className="projectContentsFile__box left">
          <ProjectFileList />
          <div className="projectContentsFile__partner">
            <ProjectSyncPartner
              useLabel
              value={selectedSyncPartner}
              setValue={setSelectedSyncPartner}
              returnPath="detail"
            />
          </div>
        </div>
        <div className="projectContentsFile__box right">
          <ProjectFileViewer />
        </div>
      </div>

      <div className="projectContentsFile__button_box">
        <MuiButton
          config={{
            color: '#0782ED',
          }}
          disabled={!localFileAllUploadValid || !!buildProcessing}
          disableElevation
          variant="contained"
          className="projectUpload__button sync_partner"
          onClick={() => {
            handleClickAllLocalFileUploadToPartner(!!partnershipCode);
          }}
        >
          <CustomSpan fontSize={14}>
            <T>PROJECT_SYNC_ALL_LOCAL_FILE</T>
          </CustomSpan>
        </MuiButton>
        {!partnershipCode ? (
          <MuiButton
            config={{
              color: '#0782ED',
            }}
            disabled={!newSyncPartnerValid || !!buildProcessing}
            disableElevation
            variant="contained"
            className="projectUpload__button sync_partner"
            onClick={() => {
              handleClickSyncNewPartner(checkedClinicFiles.value);
            }}
          >
            <CustomSpan fontSize={14}>
              <T>PROJECT_SYNC_TO_PARTNER</T>
            </CustomSpan>
          </MuiButton>
        ) : (
          <MuiButton
            config={{
              color: '#0782ED',
            }}
            // disabled={checkedClinicFiles.value.length === 0}
            disabled={!syncPartnerValid || !!buildProcessing}
            disableElevation
            variant="contained"
            className="projectUpload__button sync"
            onClick={() => {
              // handleClickUploadToPartner();
              handleCheckDuplicateUploadFile('partner', checkedClinicFiles.value);
            }}
          >
            <CustomSpan fontSize={14}>
              <T>PROJECT_SYNC_TO_PARTNER</T>
            </CustomSpan>
          </MuiButton>
        )}
        <MuiButton
          config={{}}
          // disabled={checkedClinicFiles.value.length === 0}
          // disabled={!syncGroupValid}
          disabled={!syncGroupValid || !!buildProcessing}
          disableElevation
          variant="contained"
          color="primary"
          className="projectUpload__button group"
          onClick={() => {
            handleCheckDuplicateUploadFile('group', checkedClinicFiles.value);

            // handleClickUploadToGroup();
          }}
        >
          <CustomSpan fontSize={14}>
            <T>PROJECT_SYNC_TO_GROUP</T>
          </CustomSpan>
        </MuiButton>
      </div>
    </StyledProjectContentsFile>
  );
}

const StyledProjectContentsFile = styled.div`
  .projectContentsFile__test {
    width: 300px;
    height: 300px;
    background-color: #fff;
  }
  position: relative;
  background-color: #fff;
  border-radius: 10px;
  .projectContentsFile__container {
    display: flex;
    position: relative;
    height: 710px;
    .projectContentsFile__box {
      height: inherit;
      &.left {
        width: 480px;
      }
      &.right {
        width: calc(100% - 480px);
        border-left: 1px solid #e1e1e7;
        position: relative;
        z-index: 1000;
      }

      .projectContentsFile__partner {
        height: 72px;
        width: 100%;
      }
    }
  }

  .projectContentsFile__button_box {
    width: 100%;
    position: absolute;
    display: flex;
    justify-content: center;
    margin-top: 20px;
    column-gap: 16px;
    .projectUpload__button {
      width: 260px;
      height: 46px;
    }
  }
`;

export default ProjectContentsFile;
